<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 4H5V20H19V8H15V4ZM3 2.992C3 2.444 3.447 2 3.998 2H16L21 7V20.992C21.0011 21.1234 20.9762 21.2537 20.9269 21.3755C20.8775 21.4973 20.8046 21.6082 20.7124 21.7018C20.6202 21.7954 20.5104 21.8699 20.3894 21.9211C20.2683 21.9723 20.1384 21.9991 20.007 22H3.993C3.73038 21.9982 3.47902 21.8931 3.29322 21.7075C3.10742 21.5219 3.00209 21.2706 3 21.008V2.992ZM11 12V9H13V12H16V14H13V17H11V14H8V12H11Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGNewDoc',
};
</script>

<style scoped>

</style>